import { Component, OnInit, Input, OnChanges, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos } from '../../components/common/utils/entities/util_entity';
import { ActasAccionistaService } from './actasaccionista.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription'; //<== added this


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'actasaccionista',
    templateUrl: 'actasaccionista.template.html'
})
@Injectable()
export class ActasAccionistaComponent implements OnInit {    
    usuarioEmpresa: ClienteXCiudad;
    consulta: ConsultaCarpeta;
    carpetaobj:Carpeta;
    carpetaobjAtras:Carpeta;
    carpetas: Carpeta[];
    showLoader: string;
    showLoaderTabla: string;    
    filterQuery: string;  
    archivosXCliente: Archivo[];
    datosBusqueda: BuscaArchivos;
    datosBusquedaXCliente: BuscaArchivos;
    rutaArmada: string;
    nombreCliente: string;
    usuario: ClienteLogin;
    nombrecarpetaArchivos: string;
    nombrecarpetaAtras: string;
    nombrecarpetaPadre: string;
    nombreTitulo: string;
    atrasbnt:boolean;
    private subscription: Subscription = new Subscription();
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private actasService: ActasAccionistaService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService
    ) {      

        this.archivosXCliente = new Array<Archivo>();
        this.datosBusqueda = new BuscaArchivos();
        this.datosBusquedaXCliente = new BuscaArchivos();
        this.rutaArmada = "";
        this.nombreCliente = "";
        this.usuario = new ClienteLogin();
        this.carpetaobj= new Carpeta();
        this.carpetaobjAtras= new Carpeta();
        this.atrasbnt=false;
    }
    ngOnInit(): void {
        
        this.consulta = new ConsultaCarpeta();
        this.showLoader = "sk-loading";
       
        try {
            this.usuario = JSON.parse(this.sesionStorageService.retrieve("usuario"));
           console.log(this.usuario);
        } catch (e) {
            this.usuario = this.sesionStorageService.retrieve("usuario");
            console.log(this.usuario);
        }
       
       
        if (this.usuario != null) {
            this.consulta.Carpeta = 5;
            this.consulta.Empresa = null;
            this.route.params.subscribe(params => {
                this.carpetaobj.Codigo=params['parcod'];
                console.log(params['parcod']);
                this.carpetaobj.Nombre='';
                this.nombrecarpetaArchivos='';
                this.archivosXCliente= new Array<Archivo>();
                if(this.carpetaobj.Codigo==296){
                    this.nombreTitulo='Acta';
                }
                else
                if(this.carpetaobj.Codigo==344){
                    this.nombreTitulo='Estados Financieros';
                }
                else
                if(this.carpetaobj.Codigo==345){
                    this.nombreTitulo='Informes';
                }
                
            });
            // this.datosBusquedaXCliente.Carpeta = 5;
            // this.carpetaobj.Codigo=5
            // this.carpetaobj.Nombre='';
           
        }
        this.nombrecarpetaArchivos="";
        this.nombrecarpetaPadre="";
       // console.log(this.carpetaobj);
        this.subscription = this.route.params.subscribe(val => {
            this.showLoader = "sk-loading";
            this.actasService.getCarpetas(this.carpetaobj).subscribe(
                result => {
                    this.carpetas = result;
                    console.log(this.carpetas);
                    this.carpetas.forEach(a => {
                        a.ClaseIcono = "fa-folder";
                    });
                    this.showLoader = "";
                },
                error => {
                    this.handleError.redirectUrl(error);
                    this.showLoader = "";
                });
        });
        // this.subscription =this.actasService.getCarpetas(this.carpetaobj).subscribe(
        //     result => {
        //         this.carpetas = result;
        //         console.log(this.carpetas);
        //         this.carpetas.forEach(a => {
        //             a.ClaseIcono = "fa-folder";
        //         });
        //         this.showLoader = "";
        //     },
        //     error => {
        //         this.handleError.redirectUrl(error);
        //         this.showLoader = "";
        //     });
        
       
    }
    ngOnDestroy(){ //<== added this
        
        this.subscription.unsubscribe();
    }

    verSubCarpetas(carpeta: Carpeta) {
        this.nombrecarpetaArchivos=carpeta.Nombre;
        this.archivosXCliente = carpeta.Archivos;
        this.archivosXCliente.forEach(a => {
                    if (a.Extension == "pdf")
                        a.TipoIcono = "fa-file-pdf-o";

                    if (a.Extension == "xls" || a.Extension == "xlsx")
                        a.TipoIcono = " fa-file-excel-o";

                    else
                        a.TipoIcono = "fa-file-text-o";
                });
        this.actasService.getCarpetas(carpeta).subscribe(
            result => {
                console.log(result);
                if(result.length>0){
                    this.carpetas = result;
                    this.carpetas.forEach(a => {
                        a.ClaseIcono = "fa-folder";
                    });
                    this.carpetaobjAtras=carpeta;
                    this.nombrecarpetaPadre=carpeta.Nombre;
                    this.atrasbnt=true;
                   
                }
                
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            });

    }
    Regresar() {
        
        
        this.archivosXCliente = new Array<Archivo>();
        this.carpetaobjAtras.Atras=true;
        this.actasService.getCarpetas(this.carpetaobjAtras).subscribe(
            result => {
                if(result.length>0){
                    this.carpetas = result;
                    this.carpetas.forEach(a => {
                        a.ClaseIcono = "fa-folder";
                       
                    });
                   
                }
                this.carpetaobjAtras.RutaPadre=this.carpetaobjAtras.RutaPadre.substring(0,this.carpetaobjAtras.RutaPadre.lastIndexOf("\\"));
                this.carpetaobjAtras.Ruta=this.carpetaobjAtras.Ruta.substring(0,this.carpetaobjAtras.Ruta.lastIndexOf("\\"));
                this.carpetaobjAtras.NombrePadre=this.carpetaobjAtras.RutaPadre.substring(this.carpetaobjAtras.RutaPadre.lastIndexOf("\\"));
                this.carpetaobjAtras.Nombre=this.carpetaobjAtras.Ruta.substring(this.carpetaobjAtras.Ruta.lastIndexOf("\\"));
                this.carpetaobjAtras.NombrePadre=this.carpetaobjAtras.NombrePadre.replace("\\","");
                this.carpetaobjAtras.Nombre=this.carpetaobjAtras.Nombre.replace("\\","");
                console.log(this.carpetaobjAtras);
              
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            });

           // console.log(this.carpetaobjAtras);
            if( this.carpetaobjAtras.RutaPadre ===  this.carpetaobjAtras.Raiz){
                this.nombrecarpetaArchivos="";
                this.nombrecarpetaPadre="";
                this.atrasbnt=false;
                console.log(1);
            }
            else
            {
                this.nombrecarpetaArchivos=this.carpetaobjAtras.NombrePadre
                this.nombrecarpetaPadre=this.carpetaobjAtras.NombrePadre;
                this.atrasbnt=true;
                // console.log(this.carpetaobjAtras.Ruta);
                // console.log(this.carpetaobjAtras.RutaPadre);
                // console.log(this.carpetaobjAtras.Raiz);
            }

    }
    descargar(archivo: Archivo) {
        this.showLoader = "sk-loading";
        this.actasService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                if (archivo.Extension.toUpperCase() == "DOC" ) {
                    blob = new Blob([fileBlob], {
                        type: 'application/msword'
                    });
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    });
                }
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre + ".pdf";
                }
                if (archivo.Extension.toUpperCase() == "XLSX") {
                    a.download = archivo.Nombre + ".xlsx";
                }
                if (archivo.Extension.toUpperCase() == "DOC") {
                    a.download = archivo.Nombre + ".doc";
                }
                if (archivo.Extension.toUpperCase() == "DOCx") {
                    a.download = archivo.Nombre + ".docx";
                }
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    } else 
                    if (archivo.Extension.toUpperCase() == "DOC"){
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".doc");
                    }
                    else
                    if (archivo.Extension.toUpperCase() == "DOCX"){
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".docx");
                    }
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/actasaccionista/actasaccionista.component.ts